import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("直播间管理");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("查看直播");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑直播");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增直播");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "8px",
    "color": "#999"
  }
}, "数值越大越靠前", -1);

const _hoisted_7 = /*#__PURE__*/_createTextVNode("选择招商品种");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("移除");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消");

import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Plus } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { getLiveDetail, saveLive } from '@/request';
import { uploadFile } from '@/request/api';
import { dateTimeFormat } from '@/config';
import AddAttractProductModal from '@/views/AttractInvest/AttractInvestBanner/component/AddAttractProductModal.vue';
import dayjs from 'dayjs';
export default {
  name: 'SaveLive',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const formRef = ref();
    const saving = ref(false);
    const showProdModal = ref(false);
    const isSee = computed(() => !!route.query.isSee);
    const isEdit = computed(() => !!route.query.id && !route.query.isSee);

    function formatDateTime(val) {
      if (!val) return '';
      return dayjs(val).format(dateTimeFormat);
    }

    const form = ref({
      liveId: null,
      title: '',
      liveDesc: '',
      coverUrl: '',
      anchorName: '',
      anchorAvatar: '',
      startTime: '',
      liveUrl: '',
      replayUrl: '',
      viewerCount: 0,
      sort: 0,
      productList: []
    });
    const coverFileList = ref([]);
    const avatarFileList = ref([]);
    const uploadOption = {
      name: 'file',
      action: uploadFile.url
    };
    const selectedZsProdIds = computed(() => form.value.productList.map(item => item.zsProdId));
    onMounted(() => {
      if (route.query.id) {
        loadDetail(route.query.id);
      }
    });

    function loadDetail(liveId) {
      getLiveDetail({
        liveId
      }).then(res => {
        if (!res.success) return;
        const data = res.data || {};
        form.value = {
          liveId: data.liveId,
          title: data.title || '',
          liveDesc: data.liveDesc || '',
          coverUrl: data.coverUrl || '',
          anchorName: data.anchorName || '',
          anchorAvatar: data.anchorAvatar || '',
          startTime: formatDateTime(data.startTime),
          liveUrl: data.liveUrl || '',
          replayUrl: data.replayUrl || '',
          viewerCount: data.viewerCount || 0,
          sort: data.sort || 0,
          productList: data.productList || []
        };
        coverFileList.value = data.coverUrl ? [{
          name: 'cover',
          url: data.coverUrl
        }] : [];
        avatarFileList.value = data.anchorAvatar ? [{
          name: 'avatar',
          url: data.anchorAvatar
        }] : [];
      });
    }

    function beforeImageUpload(file) {
      const isImage = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type);

      if (!isImage) {
        ElMessage.warning('仅支持 jpg/png 图片');
        return false;
      }

      if (file.size / 1024 / 1024 > 2) {
        ElMessage.warning('图片大小不能超过 2MB');
        return false;
      }

      return true;
    }

    function onCoverSuccess(res) {
      if (res.code === 1) {
        form.value.coverUrl = res.data.picUrl;
        coverFileList.value = [{
          name: 'cover',
          url: res.data.picUrl
        }];
      } else {
        ElMessage.error(res.msg || '上传失败');
      }
    }

    function onCoverRemove() {
      form.value.coverUrl = '';
      coverFileList.value = [];
    }

    function onAvatarSuccess(res) {
      if (res.code === 1) {
        form.value.anchorAvatar = res.data.picUrl;
        avatarFileList.value = [{
          name: 'avatar',
          url: res.data.picUrl
        }];
      } else {
        ElMessage.error(res.msg || '上传失败');
      }
    }

    function onAvatarRemove() {
      form.value.anchorAvatar = '';
      avatarFileList.value = [];
    }

    function onProdSelected(rows) {
      const list = Array.isArray(rows) ? rows : [rows];
      list.forEach(row => {
        if (form.value.productList.some(item => item.zsProdId === row.zsProdId)) return;
        form.value.productList.push({
          zsProdId: row.zsProdId,
          goodsId: row.goodsId,
          prodName: row.prodName,
          price: row.priceMin,
          prodMainUrl: row.picUrl
        });
      });
    }

    function removeProd(index) {
      form.value.productList.splice(index, 1);
    }

    function submit() {
      formRef.value.validate(valid => {
        if (!valid) return;
        saving.value = true;
        const params = {
          liveId: form.value.liveId || undefined,
          title: form.value.title,
          liveDesc: form.value.liveDesc,
          coverUrl: form.value.coverUrl,
          anchorName: form.value.anchorName,
          anchorAvatar: form.value.anchorAvatar || undefined,
          startTime: form.value.startTime,
          liveUrl: form.value.liveUrl || undefined,
          replayUrl: form.value.replayUrl || undefined,
          viewerCount: form.value.viewerCount,
          sort: form.value.sort,
          zsProdIdList: form.value.productList.map(item => item.zsProdId),
          __repeat: true,
          __warn: true
        };
        saveLive(params).then(res => {
          if (res.success) {
            ElMessage.success(res.msg || '保存成功');
            router.back();
          }
        }).finally(() => {
          saving.value = false;
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _unref(isSee) ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 0
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })) : _unref(isEdit) ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 1
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 2
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }))]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Back",
          type: "primary",
          link: "",
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).back())
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        disabled: _unref(isSee),
        "label-width": "120px",
        style: {
          "max-width": "900px",
          "margin-top": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "直播标题",
          prop: "title",
          rules: {
            required: true,
            message: '请输入标题'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.title = $event),
            maxlength: "200",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "简介",
          prop: "liveDesc"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.liveDesc,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.liveDesc = $event),
            type: "textarea",
            autosize: {
              minRows: 3
            },
            maxlength: "500",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "封面图",
          prop: "coverUrl",
          rules: {
            required: true,
            message: '请上传封面图'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            action: uploadOption.action,
            name: uploadOption.name,
            "list-type": "picture-card",
            limit: 1,
            disabled: _unref(isSee),
            "file-list": coverFileList.value,
            "onUpdate:file-list": _cache[3] || (_cache[3] = $event => coverFileList.value = $event),
            "on-success": onCoverSuccess,
            "on-remove": onCoverRemove,
            "before-upload": beforeImageUpload
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(Plus))]),
              _: 1
            })]),
            _: 1
          }, 8, ["action", "name", "disabled", "file-list"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "主播昵称",
          prop: "anchorName",
          rules: {
            required: true,
            message: '请输入主播昵称'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.anchorName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.anchorName = $event),
            maxlength: "64"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "主播头像",
          prop: "anchorAvatar"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            action: uploadOption.action,
            name: uploadOption.name,
            "list-type": "picture-card",
            limit: 1,
            disabled: _unref(isSee),
            "file-list": avatarFileList.value,
            "onUpdate:file-list": _cache[5] || (_cache[5] = $event => avatarFileList.value = $event),
            "on-success": onAvatarSuccess,
            "on-remove": onAvatarRemove,
            "before-upload": beforeImageUpload
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(Plus))]),
              _: 1
            })]),
            _: 1
          }, 8, ["action", "name", "disabled", "file-list"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "开播时间",
          prop: "startTime",
          rules: {
            required: true,
            message: '请选择开播时间'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: form.value.startTime,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.startTime = $event),
            type: "datetime",
            "value-format": _unref(dateTimeFormat),
            placeholder: "选择开播时间"
          }, null, 8, ["modelValue", "value-format"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "直播流地址",
          prop: "liveUrl"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.liveUrl,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.liveUrl = $event),
            placeholder: "HLS m3u8 地址，切到直播中前必填"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "回放地址",
          prop: "replayUrl"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.replayUrl,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.replayUrl = $event),
            placeholder: "mp4 地址，切到回放前必填"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "观看人数",
          prop: "viewerCount"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: form.value.viewerCount,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.viewerCount = $event),
            min: 0,
            controls: true
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "排序",
          prop: "sort"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: form.value.sort,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.sort = $event),
            controls: true
          }, null, 8, ["modelValue"]), _hoisted_6]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "挂载招商品种"
        }, {
          default: _withCtx(() => [!_unref(isSee) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[11] || (_cache[11] = $event => showProdModal.value = true)
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_table, {
            data: form.value.productList,
            border: "",
            style: {
              "margin-top": "12px"
            },
            "empty-text": "暂未挂载招商品种"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "60"
            }), _createVNode(_component_el_table_column, {
              prop: "prodName",
              label: "品种名称",
              "min-width": "180"
            }), _createVNode(_component_el_table_column, {
              prop: "goodsId",
              label: "商品ID",
              "min-width": "160",
              "show-overflow-tooltip": ""
            }), _createVNode(_component_el_table_column, {
              prop: "price",
              label: "价格",
              width: "100"
            }), !_unref(isSee) ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "操作",
              width: "100"
            }, {
              default: _withCtx(({
                $index
              }) => [_createVNode(_component_el_button, {
                type: "danger",
                link: "",
                onClick: $event => removeProd($index)
              }, {
                default: _withCtx(() => [_hoisted_8]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["data"]), _createVNode(_component_el_alert, {
            type: "info",
            closable: false,
            style: {
              "margin-top": "8px"
            },
            title: "直播挂载上架招商发布，点击跳转对应招商品种详情，用于引流"
          })]),
          _: 1
        }), !_unref(isSee) ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            loading: saving.value,
            onClick: submit
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          }, 8, ["loading"]), _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = $event => _unref(router).back())
          }, {
            default: _withCtx(() => [_hoisted_10]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model", "disabled"]), _createVNode(AddAttractProductModal, {
        checkMode: "checkbox",
        modelValue: showProdModal.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => showProdModal.value = $event),
        selectedIds: _unref(selectedZsProdIds),
        onSuccess: onProdSelected
      }, null, 8, ["modelValue", "selectedIds"])]);
    };
  }

};